<template>
	<div class="flex overflow-y-auto flex-col home-box">
		<div class="flex flex-col md:flex-row max-w-5xl home-content self-center">
			<div class="connect-panel md:w-1/3 px-4 py-2">
				<connect @update:query="val => urlArgs = val" />

				<div class="card" v-if=''>




					<div class="card-title">
						<span>直播技术交流群</span>
					</div>
					<div class="list-cantact"><img src="@/assets/img/qqgroup.png">
						<!-- <div>player.bilibili.com/player.html?aid=979353269&bvid=BV1f44y1n75h&cid=516888412&page=1</div> -->
						<div><a href="https://jq.qq.com/?_wv=1027&k=XgbY6iXV" target="_blank">946680295</a></div>
					</div>

					<div>
						<div class="card-title">
							<span>相关作品</span>
						</div>
					</div>
					<div class="list-cantact"><img src="@/assets/img/bilibili.png">
						<div><a href="https://b23.tv/l2E4NT6" target="_blank">10M_Leo</a></div>
					</div>
					<div class="list-cantact"><img src="@/assets/img/douyin.png">
						<div><a href=" https://v.douyin.com/NDhLETx/" target="_blank">LeoMan086</a></div>
					</div>
					<div class="card-title">
						<span>直播间改造/商务咨询</span>
					</div>
					<div class="list-cantact weChat-content">

						<div>
							<img src="@/assets/img/wx.jpg">
							<div>微信号：<a href="weixin://u.wechat.com/MIEHAEctIkuo6l1zzgThKHM" target="_blank">leoM865</a></div>
						</div>
					</div>
					<div class="card-title">
						<span>捐赠我们</span>
					</div>
					<div class="code-box">
						<div><img src="../../assets/img/pay-wx.jpg"></div>
						
						<div><img src="../../assets/img/pay-zfb.jpg"></div>
					</div>

				</div>
			</div>
			<div class="md:w-2/3 px-4 py-2" v-if="">

				<div class="banner-title">
					使用教程
				</div>

				<div class="video-box">
				<!-- 	<iframe src="//player.bilibili.com/player.html?aid=979353269&bvid=BV1f44y1n75h&cid=516888412&page=1"
						scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"></iframe> -->
						<iframe src="//player.bilibili.com/player.html?aid=637903124&bvid=BV1PY4y1i7c2&cid=569681202&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
				</div>
				<div class="banner-title">
					直播技术合集
				</div>
				<div class="card-title">
					<span>多机位直播</span>
				</div>
				<div class="list-box">
					<div class="video-box-m">
						<iframe src="//player.bilibili.com/player.html?aid=979353269&bvid=BV1f44y1n75h&cid=516888412&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
					</div>
					<div class="video-box-m">
						<iframe src="//player.bilibili.com/player.html?aid=464644411&bvid=BV1iL41177cv&cid=456873432&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
					</div>
				</div>
				<div class="card-title">
					<span>投屏直播</span>
				</div>
				<div class="list-box">
					<div class="video-box-m">
						<iframe src="//player.bilibili.com/player.html?aid=509952996&bvid=BV1Vu411q7qJ&cid=554323626&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
					</div>
					<div class="video-box-m">
						<iframe src="//player.bilibili.com/player.html?aid=635725946&bvid=BV15b4y1J7mB&cid=484776481&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
					</div>
					
				</div>
			</div>

		</div>
		<div class="footer-icp">
			<center style="padding: 5px 0;">
				<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">蜀ICP备2020036248号-1</a>
				&nbsp;
				<span>Copyright &copy; 2020 成都未来云教育咨询有限公司</span>
			</center>
		</div>
	</div>
</template>

<script>
	import Connect from './connect'

	export default {
		components: {
			Connect
		},
		data() {
			return {
				urlArgs: ''
			}
		},
		computed: {
			exampleURL() {
				return `${location.origin + location.pathname}#!auto${this.urlArgs}`
			},
			httpURL() {
				return location.href.replace('https://', 'http://')
			},
			showHTTPSWarning() {
				return location.protocol === 'https:'
			}
		}
	}
</script>

<style lang="postcss">
	@screen md {
		.connect-panel {
			order: 2;
		}
	}

	.card-title span {
		font-size: 16px !important;
	}

	.video-box iframe {
		width: 100%;
		height: 270px;
		border-radius: 0.18rem;
	}

	.video-box-m iframe {
		width: 100%;
		height: 185rpx;
		border-radius: 0.18rem;
	}

	.video-box {
		margin: 0 !important;
		width: 100%;
		border: 1px solid rgb(45, 55, 72);
		border-radius: 0.25rem;
		box-shadow: 0 4px 6px -1px rgb(255 255 255 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
	}


	.video-box-m {
		margin: 0 0 20px !important;
		width: 48.5%;
		border: 1px solid rgb(45, 55, 72);
		border-radius: 0.25rem;
		box-shadow: 0 4px 6px -1px rgb(255 255 255 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
	}

	.list-box>div:nth-child(odd) {
		margin-top: 10px!important;
		margin-right: 3% !important;
	}

	.banner-title {
		padding: 8px 0;
		font-size: 1.5rem;
	}

	.list-box {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}


	@media screen and (max-width: 0) {

		.video-box-m,
		.video-box iframe {
			width: 100%;
			height: 200px;
		}

		.video-box-m iframe {
			height: 100%;
		}

		.list-box>div:nth-child(odd) {
			margin-right: 0 !important;
		}
	}

	.weChat-content img {
		width: 120px !important;
	}

	.weChat-content>div {
		padding: 0 !important;
	}

	.weChat-content>div>div {
		text-align: center;
		padding-top: 5px;
	}

	img {
		background-color: #ffffff;
		border-radius: 6px;
	}

	.list-cantact {
		padding: 0 16px 8px;
		display: flex;
		align-items: center;
	}

	.list-cantact img {
		width: 18px;
	}

	.list-cantact>div {
		font-size: 12px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding-left: 8px;
	}

	.code-box {
		display: flex;
		align-items: center;
		padding: 0 16px 8px;
		flex-wrap: wrap;
	}

	.code-box>div {
		background-color: #FFFFFF;
		padding: 10px 10px 0;
		border-radius: 6px;
		margin-bottom: 10px;
	}
	.code-box>div:nth-child(1){
		margin-right: 10px;
	}

	.code-box img {
		width: 100px;

	}

	.footer-icp {
		width: 100%;
		font-size: 12px;

	}

	.footer-icp a,
	.footer-icp span {
		color: rgb(153, 154, 170) !important;
	}

	.home-box {
		height: 100%;
		display: flex;
		justify-content: space-between;
	}
</style>
